import QuoteActions from 'commons-vehicle/Quote/actions/quoteActions.js';
import QuoteActionsTypes from 'commons-vehicle/Quote/actions/quoteActionTypes.js';
import LeadTypes from 'commons-vehicle/Quote/constants/leadTypes.js';
import Statuses from 'commons-vehicle/Quote/constants/statuses.js';
import StatusesV25 from 'commons-vehicle/Quote/constants/statusesV25';
import ModelTrimItemCategories from 'commons-vehicle/Quote/constants/modelTrimItemCategories.js';
import exteriorColourStatuses from 'commons-vehicle/ModelYear/constants/exteriorColourStatuses.js';

import QuoteModel from 'commons-vehicle/Quote/models/QuoteModel.js';
import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25.js';
import SaveNewQuoteModelV25 from 'commons-vehicle/Quote/models/SaveNewQuoteModelV25.js';
import UpdateQuoteModelV25 from 'commons-vehicle/Quote/models/UpdateQuoteModelV25.js';
import QuoteItemCategoryModel from 'commons-vehicle/Quote/models/QuoteItemCategoryModel.js';
import QuoteReducer from 'commons-vehicle/Quote/reducers/quoteReducer.js';
import QuoteReducerV25 from 'commons-vehicle/Quote/reducers/quoteReducerV25.js';
import QuoteService from 'commons-vehicle/Quote/services/QuoteService/QuoteService.js';
import QuoteItemCategoryService from 'commons-vehicle/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js';

import AddToGarageButton from 'commons-vehicle/Quote/components/AddToGarage/AddToGarageButton.jsx';
import AddToGarageButtonV25 from 'commons-vehicle/Quote/components/AddToGarageV25/AddToGarageButtonV25.jsx';
import AddToGarageV25 from 'commons-vehicle/Quote/components/AddToGarageV25/AddToGarageV25.jsx';
import Finance from 'commons-vehicle/Quote/components/TransactionSummary/Finance/Finance.jsx';
import CashPurchase from 'commons-vehicle/Quote/components/TransactionSummary/CashPurchase/CashPurchase.jsx';

import en from 'commons-vehicle/Quote/i18n/en.json';
import fr from 'commons-vehicle/Quote/i18n/fr.json';

const Translation = { en, fr };

export {
    QuoteActions,
    QuoteActionsTypes,
    LeadTypes,
    Statuses,
    StatusesV25,
    ModelTrimItemCategories,
    QuoteModel,
    QuoteItemCategoryModel,
    QuoteReducer,
    QuoteReducerV25,
    QuoteService,
    QuoteItemCategoryService,
    AddToGarageButton,
    AddToGarageButtonV25, // SHOWROOM V2.5
    AddToGarageV25, // SHOWROOM V2.5
    CashPurchase,
    Finance,
    exteriorColourStatuses,
    Translation,
    QuoteModelV25, // SHOWROOM V2.5
    SaveNewQuoteModelV25, // SHOWROOM V2.5
    UpdateQuoteModelV25, // SHOWROOM V2.5
};

export default {
    QuoteActions,
    QuoteActionsTypes,
    LeadTypes,
    Statuses,
    StatusesV25, // SHOWROOM V2.5
    ModelTrimItemCategories,

    QuoteModel,
    QuoteItemCategoryModel,
    QuoteReducer,
    QuoteReducerV25,
    QuoteService,
    QuoteItemCategoryService,

    exteriorColourStatuses,

    AddToGarageButton,
    AddToGarageButtonV25, // SHOWROOM V2.5
    AddToGarageV25, // SHOWROOM V2.5
    CashPurchase,
    Finance,

    Translation,
    QuoteModelV25, // SHOWROOM V2.5
    SaveNewQuoteModelV25, // SHOWROOM V2.5
    UpdateQuoteModelV25, // SHOWROOM V2.5
};
